import React, { useState, useEffect } from "react";
import styled from "styled-components";

import watermelonImg from "../Assets/Watermelon.jpg";
import garlicImg from "../Assets/garlic.jpg";
import blackGarlicImg from "../Assets/Tablia.jpg";

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [isHovered, setIsHovered] = useState(false);

  const images = [
    { src: watermelonImg, title: "WATERMELON", description: "Sweet, juicy, farm-fresh, chemical-free. Perfect for hydration." },
    { src: garlicImg, title: "GARLIC", description: "Locally harvested garlic for your kitchen." },
    { src: blackGarlicImg, title: "TABLIA", description: "Pure cacao tablets for rich Filipino hot chocolate." },
  ];

  useEffect(() => {
    if (isHovered) return; // Stop the interval when hovered

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 1500); // Change slide every 2 seconds

    return () => clearInterval(interval);
  }, [images.length, isHovered]); // Re-run effect when hover state changes

  return (
    <CarouselContainer 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <CarouselInner>
        {images.map((image, index) => {
          const position = (index - currentIndex + images.length) % images.length;
          return (
            <ProductCard key={index} position={position}>
              <img src={image.src} alt={image.title} />
              <h2>{image.title}</h2>
              <p>{image.description}</p>
            </ProductCard>
          );
        })}
      </CarouselInner>
    </CarouselContainer>
  );
};

export default Carousel;

// Styled Components
const CarouselContainer = styled.div`
  position: relative;
  top: 50%;
  width: 100%;
  max-width: 1000px;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: -300px;
  overflow: visible;
  background-color: #fff;
`;

const CarouselInner = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const ProductCard = styled.div`
  position: absolute;
  background-color: white;
  padding: 25px;
  width: 250px; /* Increased size */
  border-radius: 15px;
  text-align: center;
  transition: all 0.5s ease-in-out;
  box-shadow: ${(props) =>
    props.position === 1 ? "0px 8px 30px rgba(0, 0, 0, 0.5)" : "0px 4px 10px rgba(0, 0, 0, 0.2)"};
  opacity: ${(props) => (props.position === 1 ? "1" : "0.7")};
  z-index: ${(props) => (props.position === 1 ? "2" : "1")};
  transform: ${(props) =>
    props.position === 0
      ? "translateX(-200px) scale(0.9)" /* Adjusted scaling */
      : props.position === 1
      ? "translateX(0px) scale(1.2)" /* Increased center size */
      : "translateX(200px) scale(0.9)"};

  img {
    width: 100%;
    height: 200px; /* Increased image size */
    object-fit: cover;
    border-radius: 12px;
  }

  h2 {
    font-size: 22px; /* Increased font size */
    margin-top: 12px;
    font-weight: bold;
  }

  p {
    font-size: 16px; /* Increased font size */
    color: gray;
  }
`;

